import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import { api } from "../../lib/api";

export function AuthFile({ file, testid }) {
  const [url, setUrl] = useState(null);
  const isImg = (file.content_type || "").startsWith("image/");
  useEffect(() => {
    let u;
    api.get(`/files/${file.path}`, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => setUrl(""));
    return () => u && URL.revokeObjectURL(u);
  }, [file.path]);
  return (
    <a href={url || undefined} target="_blank" rel="noreferrer" data-testid={testid}
      className="block w-24 h-24 rounded-xl overflow-hidden border border-slate-200 bg-slate-100 shrink-0">
      {isImg && url ? <img src={url} alt={file.name} className="w-full h-full object-cover" /> : (
        <div className="w-full h-full grid place-items-center text-center p-1">
          <div><FileText className="w-6 h-6 mx-auto text-slate-500" /><div className="text-[10px] text-slate-600 truncate w-20">{file.name}</div></div>
        </div>
      )}
    </a>
  );
}
